import React from 'react';
import styles from './ContentBox.module.scss';

import classnames from 'classnames';

interface Props {
  title?: string;
  primary?: boolean;
  children: React.ReactNode;
}

export default function ContentBox({title, children, primary}: Props) {
  const wellClassName = classnames(styles.Well, primary && styles.primary);

  return (
    <div className={styles.ContentBox}>
      {title && <p className={styles.Title}>{title}</p>}
      <div className={wellClassName}>{children}</div>
    </div>
  );
}
